import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {first} from 'rxjs/operators';
import {AlertService} from '@app/_services';
import {TeamService} from '@app/_components/team/team.service';

@Component({
    selector: 'app-team-search',
    templateUrl: './team-search.component.html',
    styleUrls: ['./team-search.component.css'],
    standalone: false
})
export class TeamSearchComponent implements OnInit, OnChanges, AfterViewInit
{
  @Input() selectedTeam: any;
  teams: any[] = [];
  @Output() onTeamSelected = new EventEmitter<any>();
  @Output() onTeamClearedEvent = new EventEmitter<any>();
  @Input() showCreateTeam = true;
  constructor(private teamService: TeamService,
              private alertService: AlertService) {
  }
  ngAfterViewInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.reflectFullName();
  }

  ngOnInit(): void {
    this.reflectFullName();
  }
  reflectFullName(){
    if (this.selectedTeam && typeof this.selectedTeam === 'object') {
      // Ensure the name field is set so PrimeNG autocomplete can display it
      if (!this.selectedTeam.name) {
        this.selectedTeam = {
          ...this.selectedTeam,
          name: this.selectedTeam.teamName || `Team ${this.selectedTeam.teamId || ''}`
        };
      }
    }
  }
  onKeyInput(event)
  {
    let query = event.query;
    this.findTeamsWith(query);
    return this.teams;
  }

  findTeamsWith(queryString: string)
  {
    this.teamService.findTeamsWith(queryString).pipe(first()).subscribe(

      data =>
      {
        console.log('taskTeam serach: ' + JSON.stringify(data));
        this.teams = [];
        this.teams = data.data.teamSummaryList;
        /*this.teams.forEach(team => {
          if ( !team.lastName) { team.lastName = ''; }
          if ( !team.firstName) { team.firstName = ''; }
          team.fullName = team.lastName + ' ' + team.firstName + ' ' + team.emailAddress + ' ' + team.teamId;
        });*/
        // console.log('QA: ' + JSON.stringify(this.taskTeamSuggestions));
      },
      error =>
      {
        // console.log('reports LIST!: ' + JSON.stringify(error));
        this.alertService.error(error);
      },
      () =>
      { }
    );
  }
  teamInfo(event: any){
    this.selectedTeam = event;
  }

  onTeamSeleted(event: any) {
    const team = event?.value ?? event;
    if (team) {
      this.selectedTeam = team;
      this.onTeamSelected.emit(team);
    }
  }
  onTeamCleared(team: any) {
    this.selectedTeam = null;
    this.onTeamClearedEvent.emit(this.selectedTeam);
  }
  emitTeamSelected(){
    if (this.selectedTeam){
      this.onTeamSelected.emit(this.selectedTeam);
    }
  }
}
